import React from 'react';
import { WarningOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { INITIATE_AUTH_DRAWER } from '../actions/types';

function NotLoggedIn() {
  const dispatch = useDispatch();

  const initiatLogin = () => {
    dispatch({
      type: INITIATE_AUTH_DRAWER,
    });
  };
  return (
    <div className='notLoggedInBox'>
      <WarningOutlined />
      <h1>
        You are not logged in. Please{' '}
        <span onClick={initiatLogin} className='loginLink'>
          login.
        </span>
      </h1>
    </div>
  );
}

export default NotLoggedIn;
